import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import uiElements from './routes/ui-elements/index'
import pages from './routes/pages'
import formsTable from './routes/forms-tables'
import others from './routes/others'
import mainApp from './routes/main-app'
import payment from './routes/payment'
import authentication from './routes/authentication'

Vue.use(VueRouter)

VueRouter.prototype.pushQuery = function pushQuery(query) {
  const url = new URL(window.location.href)
  if (Object.keys(query).length === 0) {
    window.history.pushState('', '', url.origin + url.pathname)
  } else {
    for (const [key] of url.searchParams.entries()) {
      if (!query.hasOwnProperty(key)) {
        url.searchParams.delete(key)
      }
    }
    Object.keys(query).forEach(k => {
      if (query[k] !== null) {
        url.searchParams.set(k, query[k])
      }
    })
    window.history.pushState({ path: url.href }, '', url.href)
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'index-page' } },
    ...mainApp,
    ...apps,
    ...dashboard,
    ...pages,
    ...formsTable,
    ...uiElements,
    ...others,
    ...payment,
    ...authentication,
    {
      path: '*',
      redirect: { name: 'error-404' },
    },
  ],
})

export default router
